import { NotifyHelper } from "../../../helpers/toast";
import { eCuocThaoLuanDefine } from "../../action-types/cuoc-thao-luan/ICuocThaoLuanActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const cuocThaoLuanAction = {
    ...generateActions(eCuocThaoLuanDefine, "CUOC_THAO_LUAN"),
    ...generateActionForKey(eCuocThaoLuanDefine, "CUOC_THAO_LUAN",
        "ADD_COMMENT_SUCCESS", () => NotifyHelper.Success("Sent")),
}